import React from 'react';

import Header from '../../layout/Header.jsx';
import ListBadges from '../../lists/ListBadges.jsx';

const PageBadgesList = () => (
  <div>
    <Header>Badges</Header>
    <ListBadges />
  </div>
);

export default PageBadgesList;
